<!-- regular text box below -->
@if (textBlock) {
  <div [className]="textBlock.className" [ngStyle]="getStyles()">
    @if (textBlock.text) {
      <div [innerHTML]="textBlock.text | santizeValue" id="text-block"></div>
    }
  </div>
}
